import { SaveButton } from '../../../../common/button/save-button/SaveButton';
import Modal from '../../../../common/modal/Modal';

import './missed-visit-warning/MissedVisitWarning.css';

const ChangeParticipantScheduleConfirmation = ({ show, onConfirmClick, onCancelClick }) => {
  if (!show) return null;

  return (
    <Modal headerTitle="Change participant schedule?" justifyContent="center" contentPadding="5px 15px" hideButton>
      <p className="missed-visit-warning-message">
        Are you sure you want to move the participant to a different schedule?
      </p>

      <div className="missed-visit-warning-buttons">
        <SaveButton
          textColor="#6f8695"
          border="1px solid #6f8695"
          title="Cancel"
          onClick={onCancelClick}
          color="#ffffff"
        />
        <SaveButton
          textColor="#ffffff"
          border="1px solid #6f8695"
          title="Confirm"
          onClick={onConfirmClick}
          color="#6f8695"
        />
      </div>
    </Modal>
  );
};

export default ChangeParticipantScheduleConfirmation;
